import { render, staticRenderFns } from "./OrderStudent.vue?vue&type=template&id=3ab1401a&scoped=true"
import script from "./OrderStudent.vue?vue&type=script&lang=js"
export * from "./OrderStudent.vue?vue&type=script&lang=js"
import style0 from "./OrderStudent.vue?vue&type=style&index=0&id=3ab1401a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1401a",
  null
  
)

export default component.exports